import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import {
  getApprovedAndVoidPropMaints,
  voidPropMaints,
} from "../../../api/propMaintApprovalApi";
import ApprovedPropMaintVoidForm from "../../forms/PropMaint/ApprovedPropMaintVoidForm";
import { getSignedAttachmentUrl } from "../../../api/attachApi";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

export default function ApprovedPropMaintVoidPage({ history }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [propMaints, setPropMaints] = useState([]);
  const [selectedPropMaints, setSelectedPropMaints] = useState([]);
  const [currentYear, setCurrentYear] = useState(dayjs().year());
  const [pagination, setPagination] = useState({
    current: 1,
    minIndex: 0,
    maxIndex: 100,
    pageSize: 100,
  });

  useEffect(getPropMaints, [currentYear]);

  function getPropMaints() {
    setIsLoading(true);
    getApprovedAndVoidPropMaints(currentYear)
      .then((value) => {
        // reset pagination
        resetPagination();

        setPropMaints(value ? value : []);
        setSelectedPropMaints([]);
        setIsLoading(false);
      })
      .catch((error) => {
        showErrorMessage(t("general.fail_to_load_record"), error);
      });
  }

  function resetPagination() {
    setPagination({
      current: 1,
      minIndex: 0,
      maxIndex: 100,
      pageSize: 100,
    });
  }

  function onAddNewPropMaint() {
    history("/home/propmaint/proptrans");
  }

  function onVoidPropMaints(selectedPropMaints, reason) {
    setIsLoading(true);

    voidPropMaints(selectedPropMaints, reason)
      .then(() => {
        getPropMaints();
        toast.success(t("general.record_voided_successfully"));
      })
      .catch((error) => {
        setIsLoading(false);
        showErrorMessage(t("general.fail_to_void_record"), error);
      });
  }

  function viewPropMaints(propMaintKey) {
    history("/home/propmaint/proptrans/" + propMaintKey, {
      state: { fromVoid: true },
    });
  }

  function getValidAttachments(attachments) {
    return getSignedAttachmentUrl(attachments);
  }

  function showErrorMessage(message, error) {
    let errorMsg = error.response.data.error_description
      ? error.response.data.error_description
      : error.response.data.ExceptionMessage;

    toast.error(message + (errorMsg ? errorMsg : ""));
  }

  return (
    <ApprovedPropMaintVoidForm
      isLoading={isLoading}
      data={propMaints}
      selectedItems={selectedPropMaints}
      onAdd={onAddNewPropMaint}
      onView={viewPropMaints}
      onVoided={onVoidPropMaints}
      onItemSelected={setSelectedPropMaints}
      onAttachmentClicked={getValidAttachments}
      setCurrentYear={setCurrentYear}
      pagination={pagination}
      setPagination={setPagination}
      resetPagination={resetPagination}
    />
  );
}

ApprovedPropMaintVoidPage.propTypes = {
  history: PropTypes.func.isRequired,
};
